module.exports = __webpack_public_path__ + "img/video-player/nervous@2x-39fb7e97e13ed41425e1b174a73bff62.png";